import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import style from './style.m.less'

const routes = [
    { id: 1, to: 'main', title: 'header.main' },
    { id: 2, to: 'about', title: 'header.about'},
    { id: 3, to: 'documents', title: 'header.documents' },
    { id: 4, to: 'green-tools', title: 'header.greenTools', state: {fromMenu: true} },
    { id: 5, to: 'qualification', title: 'header.qualification' },
    { id: 6, to: 'news', title: 'header.news' },
    { id: 7, to: 'generators', title: 'header.generators', state: {fromMenu: true} },
    { id: 8, to: 'owners', title: 'header.owners', state: {fromMenu: true} },
]

const FooterNav: FC = () => {
    const { t } = useTranslation()

    const navList = routes.map((route) => {
        const { id, to, title, state } = route
        return (
            <NavLink className={style.navItem} key={id} to={to} state={state}>
                {t(title)}
            </NavLink>
        )
    })

    return (
        <div className={style.footerNav}>
            <div className={style.footerHeader}>{t('footer.nav')}</div>
            <div className={style.navList}>{navList}</div>
        </div>
    )
}

export default FooterNav
